"use client";

import { ImageCard } from "@/components/cards/ImageCard";
import Link from "next/link";
import { menuStore } from "../MenuInner";
import type { Counts } from "./getCounts";

type Props = {
  counts: Counts;
};
export const Inner = ({ counts }: Props) => {
  return (
    <>
      <Link href="/themes/nouveautes/" onClick={() => menuStore.set(null)}>
        <ImageCard
          image={{
            type: "asset",
            name: "hp_th_nouveautes.png",
            realname: "hp_th_nouveautes.png",
          }}
          alt="Nouveautés"
        >
          <div className="absolute inset-4 flex flex-col gap-1.5 items-center justify-center text-center text-white">
            <p className="font-serif text-2xl italic">Nouveautés</p>
            <p className="text-base">
              {counts.nouveautes} voyage{counts.nouveautes > 1 && "s"}
            </p>
          </div>
        </ImageCard>
      </Link>
      <Link href="/bons-plans/departs-garantis/" onClick={() => menuStore.set(null)}>
        <ImageCard
          image={{
            type: "asset",
            name: "hp_th_garantis.png",
            realname: "hp_th_garantis.png",
          }}
          alt="Départs garantis"
        >
          <div className="absolute inset-4 flex flex-col gap-1.5 items-center justify-center text-center text-white">
            <p className="font-serif text-2xl italic">Départs garantis</p>
            <p className="text-base">
              {counts.garantis} voyage{counts.garantis > 1 && "s"}
            </p>
          </div>
        </ImageCard>
      </Link>
      <Link href="/bons-plans/offres-primo/" onClick={() => menuStore.set(null)}>
        <ImageCard
          image={{
            type: "asset",
            name: "hp_th_primo.png",
            realname: "hp_th_primo.png",
          }}
          alt="Offre primo"
        >
          <div className="absolute inset-4 flex flex-col gap-1.5 items-center justify-center text-center text-white">
            <p className="font-serif text-2xl italic">Offre primo</p>
            <p className="text-base">
              {counts.primos} voyage{counts.primos > 1 && "s"}
            </p>
          </div>
        </ImageCard>
      </Link>
      <Link href="/bons-plans/derniere-minute/" onClick={() => menuStore.set(null)}>
        <ImageCard
          image={{
            type: "asset",
            name: "hp_th_chances.png",
            realname: "hp_th_chances.png",
          }}
          alt="Dernière chance"
        >
          <div className="absolute inset-4 flex flex-col gap-1.5 items-center justify-center text-center text-white">
            <p className="font-serif text-2xl italic">Dernière chance</p>
            <p className="text-base">
              {counts.lasts} voyage{counts.lasts > 1 && "s"}
            </p>
          </div>
        </ImageCard>
      </Link>
    </>
  );
};
